import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { new_password_path, password_path } from '@/rails/routes';
import { Form, Link } from '@inertiajs/react';

const TEXT_LINK =
  'rounded-sm underline decoration-accent underline-offset-4 hover:decoration-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring';

interface Props {
  token: string;
  error?: string | null;
}

const Edit = ({ token, error }: Props) => {
  return (
    <>
      <h1 className="authority-display text-3xl leading-tight">Choose a new password</h1>

      <Form method="patch" action={password_path(token)} className="mt-6 flex flex-col gap-5">
        {({ processing, errors }) => (
          <>
            {error ? (
              <p
                role="alert"
                className="border-destructive text-destructive border-l-2 pl-3 text-sm"
              >
                {error}
              </p>
            ) : null}

            <div className="flex flex-col gap-2">
              <Label htmlFor="password">New password</Label>
              <Input
                id="password"
                type="password"
                name="password"
                autoComplete="new-password"
                autoFocus
                required
                aria-invalid={errors.password ? true : undefined}
                aria-describedby={
                  errors.password ? 'password_hint password_error' : 'password_hint'
                }
              />
              <p id="password_hint" className="text-muted-foreground text-sm">
                12 characters or more.
              </p>
              {errors.password ? (
                <p id="password_error" className="text-destructive text-sm">
                  {errors.password}
                </p>
              ) : null}
            </div>

            <div className="flex flex-col gap-2">
              <Label htmlFor="password_confirmation">Confirm new password</Label>
              <Input
                id="password_confirmation"
                type="password"
                name="passwordConfirmation"
                autoComplete="new-password"
                required
                aria-invalid={errors.passwordConfirmation ? true : undefined}
                aria-describedby={
                  errors.passwordConfirmation ? 'password_confirmation_error' : undefined
                }
              />
              {errors.passwordConfirmation ? (
                <p id="password_confirmation_error" className="text-destructive text-sm">
                  {errors.passwordConfirmation}
                </p>
              ) : null}
            </div>

            <Button type="submit" size="lg" disabled={processing}>
              Update password
            </Button>
          </>
        )}
      </Form>

      <p className="mt-6 text-sm">
        <Link href={new_password_path()} className={TEXT_LINK}>
          Request a new link
        </Link>
      </p>
    </>
  );
};

export default Edit;
